// Instellingen als overzicht. Engelse tegenhanger van settingsHub.nl.ts.
export const appSettingsHubEn = {
    groups: {
        family: {
            title: 'Our family',
            titleHouse: 'Our household',
            body: 'Who belongs, the language and what suits you.',
        },
        agenda: {
            title: 'Calendar',
            body: 'Bring in outside calendars, share and export.',
        },
        board: {
            title: 'Board and tablets',
            body: 'The tablets on the wall, the rooms, the lock and the weather.',
        },
        modules: {
            title: 'Modules',
            body: 'Which parts you use, each with its own settings.',
        },
        account: {
            title: 'Your account',
            body: 'Sign-in and security, notifications on your phone and how the app looks.',
        },
        privacy: {
            title: 'Privacy and data',
            body: 'Download or erase your data, and who may look along.',
        },
    },
    household: {
        title: 'Household',
        intro: 'Name, language and type of household in one place.',
        nameTitle: 'Name and time zone',
        nameBody: 'The name appears on the board and in emails.',
    },
    calendar: {
        title: 'Link and export the calendar',
        intro: 'Subscription links, travel time and the calendar as a file.',
    },
    locationWeather: {
        title: 'Location and weather',
        intro: 'Where you live, and what the board shows about the weather.',
    },
    // WP3: vijf onderdelen, Bord en Gezin met tabbladen.
    sections: {
        label: 'Settings sections',
        household: 'Household',
        family: 'Family and traditions',
        house: 'What suits our home',
        agenda: 'Calendar',
        modules: 'Modules',
        account: 'Account and privacy',
        accountState: 'Security, notifications, theme and your data',
    },
    change: 'Change',
    /** Rechts in een regel die alleen uitleg opent (geen keuze). */
    view: 'View',
    rows: {
        name: 'Name and time zone',
        language: 'Language',
        type: 'Type of household',
        location: 'Location',
        weather: 'Weather on the board',
        feeds: 'Outside calendars',
        feedsState: 'School, sports and work in your calendar',
        sync: 'Connect Google or Outlook',
        syncState: 'Both ways, per person',
        links: 'Subscription links',
        linksState: 'Your calendar in another app (one way)',
        export: 'Export',
        exportState: 'The calendar as a file (.ics)',
        theme: 'Theme and pictograms',
        about: 'About AMUMIN',
        off: 'Off',
        nothing: 'Nothing chosen yet',
        ownChoices: 'Own choices: {names}',
    },
    hubs: {
        board: {
            title: 'Board',
            tabs: 'Board sections',
            view: 'Display',
            tablets: 'Tablets',
            rooms: 'Rooms',
            frame: 'Photo frame',
            kidLock: 'Child lock',
        },
        family: {
            title: 'Family',
            tabs: 'Family sections',
            members: 'Members',
            links: 'Relatives',
            circle: 'Circle',
        },
    },
    tablets: {
        none: 'No tablet connected yet.',
        guide: 'How to connect an iPad',
    },
    members: {
        order: 'Order',
        orderDone: 'Done',
    },
    modulesCount: '{on} of {total} on',
    privacyStatement: 'Privacy statement',
    privacyStatementBody: 'What we keep, why and for how long.',
    haptics: {
        label: 'Vibrate on tap',
        hint: 'A short vibration when you press something (only on a phone that can).',
        boardHint: 'A short vibration when someone presses something on the board. An iPad does not vibrate; there you still see the press.',
    },
};
//# sourceMappingURL=settingsHub.en.js.map